// Supabase has been replaced by the custom PHP API (api.masterlevel.de).
// This stub keeps legacy offline-caching code (audioPlayback, useCachedImage,
// autoCache) from crashing until those paths are rewritten for the new backend.
// Storage always returns null — signed URLs are no longer available.

interface SignedUrlResult { data: { signedUrl: string } | null; error: null }
interface DownloadResult  { data: Blob | null; error: null }

export const supabase = {
  storage: {
    from: (_bucket: string) => ({
      createSignedUrl: async (_path: string, _ttl: number): Promise<SignedUrlResult> =>
        ({ data: null, error: null }),
      download: async (_path: string): Promise<DownloadResult> =>
        ({ data: null, error: null }),
      upload: async (_path: string, _blob: Blob): Promise<{ error: { message: string } | null }> =>
        ({ error: { message: 'File upload not yet supported' } }),
    }),
  },
}
